exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-type-group[data-v-24d3b020]{margin-right:auto}.tip-text[data-v-24d3b020]{color:#909399;font-size:12px;line-height:1.6}.dialog-footer[data-v-24d3b020]{display:flex;justify-content:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-24d3b020&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/UserAdminister/MemberSale/MemberSale.vue
// module id = 474
// module chunks = 0